import * as Redux from 'redux'
import * as Constants from './constants'

export const reducer = Redux.combineReducers({
  loginInProgress: (state = false, {type, value}) => type === Constants.LOGIN_IN_PROGRESS ? value : state,
  loginFailed: (state = false, {type, value}) => type === Constants.LOGIN_FAILED ? value : state,
  loginFailedMessage: (state = '', {type, message}) => type === Constants.LOGIN_FAILED ? message : state,
  facebookAppId: (state = null, {type, value}) => type === Constants.SET_FACEBOOK_APP_ID ? value : state,
})
